import React from 'react'
import { AlertDefault, ModalClosed, SubmitConfirm } from '~misc/icons';
import { Link, useNavigate } from "react-router-dom";
import { initialPath } from "~misc/paths";

const ModalForm = ({ isOpen, onClose, title, status, link }) => {
  const modalClasses = isOpen ? 'fixed inset-0 bg-black bg-opacity-50 z-[99999]' : 'hidden';
  const overlayClasses = isOpen ? 'fixed inset-0 bg-black opacity-50 z-40' : 'hidden';
  const navigate  = useNavigate();
  const statusMap = {
    alert: <AlertDefault />,
    submit: <SubmitConfirm />
  };

  return (
    <div className={modalClasses}>
      <div className="fixed inset-0 flex items-center justify-center">
        <div className="bg-white px-14 py-14 rounded-[20px] shadow-lg z-50 text-center relative">
          <div className="flex justify-end">
            <button type='button' onClick={onClose} className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0">
              <ModalClosed />
            </button>
          </div>
          {status && (
            <>
              <span className={`${status === "submit" ? 'flex justify-center ' : 'flex justify-center mb-4'}`}>
                {statusMap[status]}
              </span>
            </>
          )}
          <h3 className='font-bold text-2xl max-w-[400px] m-auto'>{title} </h3>

          <div className="flex justify-center gap-3 mt-3">

          <button onClick={() => {
            onClose();
           if(link){
            navigate(`${initialPath}/${link}`);
           }
          }} type='button' className='px-6 py-3 rounded bg-secundaria text-primaria font-bold  hover:bg-white hover:text-secundaria border-2 border-secundaria border-quartenaria transition duration-300 ease-in-out'>
              Ok
            </button>
          </div>
        </div>
        <div className={overlayClasses} onClick={onClose}></div>
      </div>
    </div>

  );
};
export default ModalForm